<template>
<CheckMISCBalToGL/>
</template>

<script>
import CheckMISCBalToGL from '../../../components/Gl/CheckMISCBalToGL/CheckMISCBalToGL.vue';

export default {
  components: {
    CheckMISCBalToGL,
  },
};

</script>
